/* eslint-disable no-restricted-imports */
// FSD VIOLATION: Layout component that composes upload widget and weave feature.
// Moving to widgets would break features that import it.
import { useExperiments } from "@design-lab/shared/lib/config";
import { shouldReorderDesignLabTabs } from "@design-lab/shared/lib/experiments";
import { UploadArtwork } from "@design-lab/widgets/design-lab-upload-artwork";
import { FrontBackSubTabs } from "./FrontBackSubTabs";

/**
 * Reusable component that renders UploadArtwork.
 * When ab_design_lab_reorder_tabs experiment is enabled, shows Front/Back sub-tabs.
 */
export function UploadSection() {
  const experiments = useExperiments();
  const showSubTabs = shouldReorderDesignLabTabs(experiments?.abDesignLabReorderTabs);

  // A/B Test Variant: Show sub-tabs for Front/Back
  if (showSubTabs) {
    return (
      <FrontBackSubTabs
        title="Upload"
        number={1}
        testIdPrefix="upload"
        frontContent={<UploadArtwork side="front" />}
        backContent={<UploadArtwork side="back" />}
      />
    );
  }

  // Control: Original behavior without sub-tabs
  return <UploadArtwork />;
}
